import { Button, Card, Col, Form } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JRow, JTable, JTBody, JTHead, JvCaption } from "../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpLong } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { InfTermCarregInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useEffect, useRef, useState } from "react";
import { formatMoeda, getUuidV4, goToFocus } from "../../../utils/utils";
import { addTerminalCarrega, removeTerminalCarrega, removeTerminalCarregaTodos } from "../../../features/manifestoSlice";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";

const LIMITE: number = 5;

const initialState: InfTermCarregInterface = {
    id: 0,
    ctermcarreg: '',
    xtermcarreg: '',
}

export default function TerminalCarregamento() {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico.infTermCarreg);
    const [form, setForm] = useState<InfTermCarregInterface>(initialState);
    const codTerminal = useRef<HTMLInputElement>(null)
    const nomeTerminal = useRef<HTMLInputElement>(null)
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();
    const [saldo, setSaldo] = useState<number>(0);

    const validaPreenchimento = () => {
        if (form.ctermcarreg.toString() === "") {
            alertModal('Informe o Código do terminal');
            goToFocus(codTerminal);
            return false;
        }

        if (form.xtermcarreg.toString() === "") {
            alertModal('Informe o nome do terminal');
            goToFocus(nomeTerminal);
            return false;
        }

        if (lista.length >= LIMITE) {
            alertModal(`Limite de ${formatMoeda(LIMITE, 0)} terminais atingido.`);
            return false;
        }

        if (lista.find((item: InfTermCarregInterface) => item.ctermcarreg.trim() === form.ctermcarreg.trim())) {
            alertModal('Código do terminal já adicionado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addTerminalCarrega({ ...form, id: getUuidV4() }))
            setForm(initialState);
            goToFocus(codTerminal);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover Cod. Terminal: <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeTerminalCarrega(value.id));
        }
        setSelecionado('')
    }

    const handleRemoverTodos = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeTerminalCarregaTodos());
            }
        }
    }
    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        setSaldo(lista.length);
    }, [lista])

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header><FontAwesomeIcon icon={faUpLong} className="text-success" />  Informações dos terminais de carregamento <span
                className="text-primary fw-semibold">(Opcional)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md={3}>
                        <Form.Group controlId="aquav-tc-ctermcarreg">
                            <Form.Label>* Código</Form.Label>
                            <Form.Control type="text" name="ctermcarreg"
                                title="Código identificador do terminal"
                                maxLength={8} value={form.ctermcarreg}
                                
                                ref={codTerminal}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="aquav-tc-xtermcarreg">
                            <Form.Label>* Nome do Terminal</Form.Label>
                            <Form.Control type="text" name="xtermcarreg"
                                title="Nome do terminal"
                                maxLength={60} value={form.xtermcarreg}
                                
                                ref={nomeTerminal}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">
                        <Button title="Adicionar" variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </Col>
                </JRow>

                <JTable>
                    <JvCaption>({saldo} de {LIMITE} no máximo)</JvCaption>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '4rem' }}>
                                <ButtonTrash onClick={() => handleRemoverTodos()} />
                            </th>
                            <th className="text-center">Cód. Terminal</th>
                            <th className="text-center" >Nome Terminal</th>
                        </tr>
                    </JTHead>

                    <JTBody>
                        {lista?.map((item: InfTermCarregInterface) => (
                            <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.xtermcarreg })} />
                                </td>
                                <td className="text-center">{item.ctermcarreg}</td>
                                <td className="text-center">{item.xtermcarreg}</td>
                            </tr>
                        ))}
                    </JTBody>
                </JTable>

            </Card.Body>
        </Card>
        {ModalMessageEl}
        {ConfirmModal}

    </>)
}